export const RG_INTERACTION_PERIOD_DAY = 60;
export const RG_INTERACTION_PERIOD_NIGHT = 30;

export const RG_INTERACTIONS_ALERT_TIME_ID = "RG_INTERACTIONS_ALERT_TIME_ID";
export const RG_INTERACTIONS_ALERT_LOSS_ID = "RG_INTERACTIONS_ALERT_LOSS_ID";
export const RG_INTERACTIONS_ALERT_WAGERING_ID = "RG_INTERACTIONS_ALERT_WAGERING_ID";
export const RG_INTERACTIONS_ALERT_DEPOSIT_ID = "RG_INTERACTIONS_ALERT_DEPOSIT_ID";
export const RG_INTERACTIONS_ALERT_TOOLS_ID = "RG_INTERACTIONS_ALERT_TOOLS_ID";
